module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('certificates') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Manage Certificates"
    }
  })], 1) : _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [(_vm.role != 'ToolAdmin') ? _c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v(" Manage Certificates ")])]), _vm._v(" "), (_vm.$hydrowareSecurityJS.canAdd_A('certificates')) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.addCertificateTopic()
      }
    }
  }, [_vm._v("\n                  Add Certificate\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "x_content"
  }, [_c('el-row'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [
    [(_vm.isaddCertificateTopic) ? _c('div', [_c('el-row', {
      attrs: {
        "gutter": 24
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 18,
        "md": 18,
        "sm": 18
      }
    }, [_c('label', {
      staticClass: "el-form-item__label"
    }, [_vm._v("Certificate Name")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "Certificate Name"
      },
      model: {
        value: (_vm.CertificateTopicName),
        callback: function($$v) {
          _vm.CertificateTopicName = $$v
        },
        expression: "CertificateTopicName"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 6,
        "md": 6,
        "sm": 6
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-top": "43px",
        "height": "36px"
      },
      attrs: {
        "type": "primary",
        "size": "medium",
        "icon": "el-icon-plus"
      },
      on: {
        "click": function($event) {
          return _vm.createCertificateTopic()
        }
      }
    }, [_vm._v("\n                                Add\n                              ")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-top": "43px",
        "height": "36px"
      },
      attrs: {
        "type": "primary",
        "icon": "el-icon-circle-close-outline",
        "size": "medium"
      },
      on: {
        "click": function($event) {
          return _vm.canceladdTopic()
        }
      }
    }, [_vm._v("\n                                Cancel\n                              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "gutter": 20
      }
    }, _vm._l((_vm.AgencyCertificateList), function(item) {
      return _c('div', {
        key: item.CertificateId
      }, [_c('div', {
        staticClass: "row",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "col-md-4 col-lg-4"
      }, [(!item.iseditCertificateName) ? _c('div', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [(item.showChild) ? _c('i', {
        staticClass: "fa fa-caret-down",
        staticStyle: {
          "color": "white!important",
          "font-size": "19px"
        },
        on: {
          "click": function($event) {
            return _vm.togglechildnodes(item.CertificateNameId)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!item.showChild) ? _c('i', {
        staticClass: "fa fa-caret-right",
        staticStyle: {
          "color": "white!important",
          "font-size": "19px"
        },
        on: {
          "click": function($event) {
            return _vm.togglechildnodes(item.CertificateNameId)
          }
        }
      }) : _vm._e(), _vm._v("\n                                " + _vm._s(item.CertificateName) + "\n                              ")]) : _vm._e(), _vm._v(" "), (item.iseditCertificateName) ? _c('div', [_c('div', {
        staticClass: "col-md-6 col-lg-6"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "Please input",
          "size": "mini"
        },
        model: {
          value: (item.EditCertificatename),
          callback: function($$v) {
            _vm.$set(item, "EditCertificatename", $$v)
          },
          expression: "item.EditCertificatename"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-1 col-lg-1"
      }, [_c('el-button', {
        staticClass: "fa fa-floppy-o",
        staticStyle: {
          "background-color": "green !important",
          "color": "#c3c8cc !important"
        },
        attrs: {
          "size": "mini",
          "title": "Save"
        },
        on: {
          "click": function($event) {
            return _vm.UpdateCertificateName(item)
          }
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-1 col-lg-1"
      }, [_c('el-button', {
        staticStyle: {
          "background-color": "rgb(255,73,73) !important",
          "border-color": "red !important",
          "color": "#c3c8cc !important"
        },
        attrs: {
          "icon": "el-icon-close",
          "size": "mini",
          "title": "Cancel"
        },
        on: {
          "click": function($event) {
            return _vm.cancelEditCertificateName(item)
          }
        }
      })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.$hydrowareSecurityJS.canAdd_A('certificates')) ? _c('div', {
        staticClass: "col-md-2 col-lg-2"
      }, [_c('el-button', {
        attrs: {
          "icon": "el-icon-plus",
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.viewadd(item.CertificateNameId)
          }
        }
      }, [_vm._v("\n                                  Add Certifying Agency\n                              ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-1 col-lg-1"
      }, [(!item.IsDefault) ? _c('div', [(_vm.$hydrowareSecurityJS.canEdit_A('certificates') && item.IsDirectorCustom) ? _c('div', [_c('hydroware-edit-button', {
        on: {
          "click": function($event) {
            return _vm.enableEditCertificateName(item)
          }
        }
      })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (item.showChild) ? _c('div', {
        staticStyle: {
          "margin-top": "20px"
        }
      }, [(!item.Agencies) ? _c('div', [_c('div', {
        staticClass: "col-md-4"
      }), _vm._v("\n                              No Certifying Agencies ")]) : _vm._e(), _vm._v(" "), _vm._l((item.Agencies), function(agency) {
        return _c('div', {
          key: agency.CertificateId,
          staticClass: "row",
          staticStyle: {
            "margin-top": "10px"
          }
        }, [_c('div', {
          staticClass: "col-md-1 col-lg-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 col-lg-3",
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("\n                                " + _vm._s(agency.CertificateAgencyName) + "\n                              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-1 col-lg-1"
        }, [_vm._v("\n                                " + _vm._s(agency.ExpiryPeriod + " " + agency.ExpiryStatus) + "\n                              ")]), _vm._v(" "), (!agency.IsDefault) ? _c('div', {
          staticClass: "col-md-1 col-lg-1"
        }, [(_vm.$hydrowareSecurityJS.canEdit_A('certificates') && agency.IsDirectorCustom) ? _c('div', [_c('div', [(_vm.$hydrowareSecurityJS.canEdit_A('certificates')) ? _c('el-button', {
          staticStyle: {
            "background-color": "rgb(32, 160, 255) !important",
            "border": "1px solid rgb(32, 160, 255)",
            "color": "white !important"
          },
          attrs: {
            "icon": "el-icon-edit",
            "size": "mini",
            "title": "Edit"
          },
          on: {
            "click": function($event) {
              return _vm.editCertificate(agency, item)
            }
          }
        }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!agency.IsDefault) ? _c('div', {
          staticClass: "col-md-1 col-lg-1"
        }, [((agency.IsDirectorCustom)) ? _c('div', [(_vm.$hydrowareSecurityJS.canDelete_A('certificates')) ? _c('el-button', {
          staticStyle: {
            "background-color": "rgb(255, 73, 73) !important",
            "border": "1px solid #e64242",
            "color": "white !important"
          },
          attrs: {
            "icon": "el-icon-delete",
            "size": "mini",
            "title": "Delete"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCertificate(agency)
            }
          }
        }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-md-1 col-lg-1"
        }, [(!agency.IsDefault) ? _c('div', [(agency.IsActive) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Not Active")])]) : _vm._e()])])
      }), _vm._v(" "), (item.isaddChild) ? _c('div', {
        staticClass: "row",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "col-md-1"
      }), _vm._v(" "), (!_vm.isediting) ? _c('div', {
        staticClass: "col-md-4 el-form-item__content"
      }, [_c('el-select', {
        staticStyle: {
          "width": "100%!important"
        },
        attrs: {
          "placeholder": "Select Agency"
        },
        model: {
          value: (_vm.selectedagency),
          callback: function($$v) {
            _vm.selectedagency = $$v
          },
          expression: "selectedagency"
        }
      }, _vm._l((_vm.Agencylist), function(item) {
        return _c('el-option', {
          key: item.Id,
          attrs: {
            "label": item.Name,
            "value": item.Id
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isediting) ? _c('div', {
        staticClass: "col-md-4 el-form-item__content"
      }, [_c('el-select', {
        staticStyle: {
          "width": "100%!important"
        },
        attrs: {
          "placeholder": "Select "
        },
        model: {
          value: (_vm.selectedagency),
          callback: function($$v) {
            _vm.selectedagency = $$v
          },
          expression: "selectedagency"
        }
      }, _vm._l((_vm.agencydropdown), function(agency) {
        return _c('el-option', {
          key: agency.Id,
          attrs: {
            "label": agency.Name,
            "value": agency.Id
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedagency == 0) ? _c('div', {
        staticClass: "col-md-2"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "New Certifying Agency",
          "disabled": _vm.isNewCertificates
        },
        model: {
          value: (_vm.Certificate.CertificateAgency),
          callback: function($$v) {
            _vm.$set(_vm.Certificate, "CertificateAgency", $$v)
          },
          expression: "Certificate.CertificateAgency"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_c('el-button', {
        attrs: {
          "type": "primary",
          "disabled": _vm.Certificate.ExpiryPeriod < 2,
          "size": "small"
        },
        on: {
          "click": function($event) {
            _vm.Certificate.ExpiryPeriod = _vm.Certificate.ExpiryPeriod - 1
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-minus",
        staticStyle: {
          "font-size": "10px"
        }
      })]), _vm._v(" "), (_vm.Certificate.ExpiryPeriod.length == 0) ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm.Certificate.ExpiryPeriod = 1) + "\n                                ")]) : _c('span', [_vm._v(_vm._s(_vm.Certificate.ExpiryPeriod))]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "primary",
          "size": "small"
        },
        on: {
          "click": function($event) {
            _vm.Certificate.ExpiryPeriod = (_vm.Certificate.ExpiryPeriod - 1) + 2
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-plus",
        staticStyle: {
          "font-size": "10px"
        }
      })])], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [(_vm.Certificate.ExpiryStatus.length == 0) ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm.Certificate.ExpiryStatus = 'Years') + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('el-select', {
        attrs: {
          "size": "small"
        },
        model: {
          value: (_vm.Certificate.ExpiryStatus),
          callback: function($$v) {
            _vm.$set(_vm.Certificate, "ExpiryStatus", $$v)
          },
          expression: "Certificate.ExpiryStatus"
        }
      }, _vm._l((_vm.ExpiryStatusList), function(item) {
        return _c('el-option', {
          key: item.Value,
          attrs: {
            "label": item.Status,
            "value": item.Value
          }
        })
      }), 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_c('el-checkbox', {
        model: {
          value: (_vm.Certificate.IsActive),
          callback: function($$v) {
            _vm.$set(_vm.Certificate, "IsActive", $$v)
          },
          expression: "Certificate.IsActive"
        }
      }, [_vm._v("\n                                  Active\n                                ")])], 1), _vm._v(" "), (!_vm.isediting) ? _c('div', {
        staticClass: "col-md-2"
      }, [_c('el-button', {
        staticClass: "fa fa-floppy-o",
        staticStyle: {
          "background-color": "green !important",
          "border-color": "green !important",
          "color": "#c3c8cc !important"
        },
        attrs: {
          "size": "small",
          "title": "Save"
        },
        on: {
          "click": function($event) {
            return _vm.addCertificate(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.isediting) ? _c('div', {
        staticClass: "col-md-2"
      }, [_c('el-button', {
        staticClass: "fa fa-floppy-o",
        staticStyle: {
          "background-color": "green !important",
          "border-color": "green !important",
          "color": "#c3c8cc !important"
        },
        attrs: {
          "size": "small",
          "title": "Update"
        },
        on: {
          "click": function($event) {
            return _vm.updateCertificate(item)
          }
        }
      })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')], 2) : _vm._e()])
    }), 0)]
  ], 2)], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "AddCertificatemodel",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-color": "#6DC8F4",
      "border-radius": "inherit"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.modalTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('el-form', {
    ref: "AddCertificateForm",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.AddCertificateForm,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Name",
      "label": "Name:",
      "rules": [{
          required: true,
          message: 'This field is required',
          trigger: 'blur'
        },
        {
          min: 1,
          max: 200,
          message: 'Length should be 1 to 200'
        }
      ]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.AddCertificateForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "Name", $$v)
      },
      expression: "AddCertificateForm.Name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Description",
      "label": "Description:",
      "rules": [{
          required: false
        },
        {
          min: 1,
          max: 200,
          message: 'Length should be 1 to 200'
        }
      ]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.AddCertificateForm.Description),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "Description", $$v)
      },
      expression: "AddCertificateForm.Description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "IssuedBy",
      "label": "Issued By:",
      "rules": [{
          required: true,
          message: 'This field is required',
          trigger: 'blur'
        },
        {
          min: 1,
          max: 200,
          message: 'Length should be 1 to 200'
        }
      ]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.AddCertificateForm.IssuedBy),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "IssuedBy", $$v)
      },
      expression: "AddCertificateForm.IssuedBy"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('el-form-item', {
    staticClass: "col-md-5 col-lg-5",
    attrs: {
      "prop": "ExpiryPeriod",
      "label": "Expiry Period:"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkNumber
    },
    model: {
      value: (_vm.AddCertificateForm.ExpiryPeriod),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "ExpiryPeriod", $$v)
      },
      expression: "AddCertificateForm.ExpiryPeriod"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "col-md-3 col-lg-3",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.AddCertificateForm.ExpiryPeriodStatus),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "ExpiryPeriodStatus", $$v)
      },
      expression: "AddCertificateForm.ExpiryPeriodStatus"
    }
  }, _vm._l((_vm.pdays), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "col-md-4 col-lg-4",
    staticStyle: {
      "color": "white",
      "margin-top": "10px"
    },
    model: {
      value: (_vm.AddCertificateForm.IsActive),
      callback: function($$v) {
        _vm.$set(_vm.AddCertificateForm, "IsActive", $$v)
      },
      expression: "AddCertificateForm.IsActive"
    }
  }, [_vm._v("\n                    Active\n                ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.cancelpopup()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), (_vm.IsCertificateTypeEdit) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.EditCertificateType(_vm.AddCertificateForm)
      }
    }
  }, [_vm._v("\n              Update\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.IsCertificateTypeEdit) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('AddCertificateForm')
      }
    }
  }, [_vm._v("\n              Create\n            ")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146dd428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Certificates/managecertificates.vue
// module id = 773
// module chunks = 1